import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ParticipantFieldConfigFormProps from './ParticipantFieldConfigFormProps';
import UI from '../../../../../common/UI';

interface Config {
  require_competition_license: boolean;
  require_elearning_bronze: boolean;
  require_elearning_silver: boolean;
  require_elearning_gold: boolean;
}

const AuLicenseConfigForm = ({ config: initialConfig, onChange }: ParticipantFieldConfigFormProps) => {
  const { t } = useTranslation();

  const [config, setConfig] = useState<Config>((initialConfig as any) || {
    require_competition_license: false,
  });

  const toggleMembershipId = () => {
    setConfig((current) => ({
      ...current,
      require_competition_license: !current.require_competition_license,
    }));
  };

  const toggleRequireElearningBronze = () => {
    setConfig((current) => ({
      ...current,
      require_elearning_bronze: !current.require_elearning_bronze,
    }));
  };

  const toggleRequireElearningSilver = () => {
    setConfig((current) => ({
      ...current,
      require_elearning_silver: !current.require_elearning_silver,
    }));
  };

  const toggleRequireElearningGold = () => {
    setConfig((current) => ({
      ...current,
      require_elearning_gold: !current.require_elearning_gold,
    }));
  };

  useEffect(() => {
    onChange(config);
  }, [config]);

  return (
    <UI.InputGroup>
      <UI.InputLabel>
        {t('options')}
      </UI.InputLabel>
      <UI.InputDescription>
        {t('au_license_field.competition_license_description')}
      </UI.InputDescription>
      <UI.Checkbox
        onChange={() => toggleMembershipId()}
        checked={config.require_competition_license}
      >
        {t('au_license_field.require_competition_license')}
      </UI.Checkbox>
      <UI.Checkbox
        onChange={() => toggleRequireElearningBronze()}
        checked={config.require_elearning_bronze}
      >
        {t('au_license_field.require_elearning_bronze')}
      </UI.Checkbox>
      <UI.Checkbox
        onChange={() => toggleRequireElearningSilver()}
        checked={config.require_elearning_silver}
      >
        {t('au_license_field.require_elearning_silver')}
      </UI.Checkbox>
      <UI.Checkbox
        onChange={() => toggleRequireElearningGold()}
        checked={config.require_elearning_gold}
      >
        {t('au_license_field.require_elearning_gold')}
      </UI.Checkbox>
    </UI.InputGroup>
  );
};

export default AuLicenseConfigForm;
